import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'PerformanceSolutionTemplate') {
      child.current?.setState({ showModal: true, componentType: 'Create' });
    }
  })
}

export function showAssessmentMethodDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ assessmentMethodShow: true });
}
